import type { DrillAdvancedFiltersPayload, DrillChecksPayload, DrillSimpleFiltersPayload } from "@/@types/price-markdown-selection";
import { DEFAULT_DRILL_CHECKS } from "../../constants";

export interface IDrillFilters {
  simpleFilters: DrillSimpleFiltersPayload;
  checks: DrillChecksPayload;
  advancedFilters: DrillAdvancedFiltersPayload;
}

export type DrillFilterGroup = keyof IDrillFilters;

export type UpdateDrillFiltersPayload = {
  [G in DrillFilterGroup]: {
    markdownId: string;
    group: G;
    value: IDrillFilters[G];
  };
}[DrillFilterGroup];

export interface FilterStateDrill {
  porRemarcacao: Record<string, IDrillFilters>;
}

export const DEFAULT_DRILL_FILTERS: IDrillFilters = {
  simpleFilters: {},
  checks: { ...DEFAULT_DRILL_CHECKS },
  advancedFilters: {},
};

export const DRILL_FILTER_KEY_SEPARATOR = ":";
